import React from "react";

import { Container, Typography } from "@mui/material";
import { DesqualifiedList } from "components/Desqualified";
import { HeaderApp } from "components/Header";

const DesqualifiedPage: React.FC = () => {
  return (
    <>
      <HeaderApp />
      <Container maxWidth="xl">
        <Typography variant="h5" sx={{ marginTop: "20px" }}>
          DESCREDENCIADOS
        </Typography>
        <DesqualifiedList />
      </Container>
    </>
  );
};

export { DesqualifiedPage };
